import { useEmailAction } from './useEmailAction';
import { useUserCommunicationsStore } from '../../../store';

export const useCreateUserCommunication = () => {
  const { setCreateLoading } = useUserCommunicationsStore();

  const { handleEmailAction } = useEmailAction(() => ({
    setLoading: setCreateLoading,
    successKey: 'inbox.userCommunication.actions.createSuccess',
    errorKey: 'inbox.userCommunication.actions.createError',
  }));

  return { handleCreateUserCommunication: handleEmailAction };
};
